"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartEventType = void 0;
var CartEventType;
(function (CartEventType) {
    CartEventType["RedeemValueVoucher"] = "Redeem Value Voucher";
    CartEventType["SelectShippingMethod"] = "SelectShippingMethod";
    CartEventType["IncreaseAmount"] = "IncreaseAmount";
    CartEventType["DecreaseAmount"] = "DecreaseAmount";
    CartEventType["DeleteItem"] = "DeleteItem";
    CartEventType["EditOrderDetails"] = "EditOrderDetails";
})(CartEventType || (exports.CartEventType = CartEventType = {}));
//# sourceMappingURL=CartEventType.js.map